import React, { useState } from 'react';

const DownloadFileButton = ({
    route,
    filename = 'download.gz',
    buttonText = 'Download File',
    apiCall // Pass your custom apiCall wrapper function here
}) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [error, setError] = useState(null);

    const handleDownload = async () => {
        if (isDownloading) return;

        setIsDownloading(true);
        setError(null);

        try {
            // 1. Fetch the data from your PHP backend
            const response = await apiCall(route);

            // Handle server error responses cleanly
            if (!response.ok) {
                // If the server returned JSON error metadata instead of a file binary stream
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    const errData = await response.json().catch(() => ({}));
                    throw new Error(errData.error || `Server responded with status ${response.status}`);
                }
                throw new Error('Network response was not ok');
            }

            const reader = response.body.getReader();

            // 2. Create a stream to handle incoming chunks
            const stream = new ReadableStream({
                async start(controller) {
                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) break;
                        controller.enqueue(value);
                    }
                    controller.close();
                }
            });

            // 3. Convert the stream to a Blob URL
            const streamResponse = new Response(stream);
            const blob = await streamResponse.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            // 4. Trigger the download automatically
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // 5. Clean up memory
            link.remove();
            window.URL.revokeObjectURL(blobUrl);

        } catch (err) {
            console.error('Streaming download failed:', err);
            setError(err.message || 'Failed to download file.');
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <div>
            <button
                onClick={handleDownload}
                disabled={isDownloading}
                className={`mt-4 cursor-pointer bg-orange-300 text-white px-4 py-2 rounded disabled:opacity-50 download-btn ${isDownloading ? 'loading' : ''}`}
            >
                {isDownloading ? 'Downloading...' : buttonText}
            </button>

            {error && <p className="download-error-msg" style={{ color: 'red', marginTop: '5px' }}>{error}</p>}
        </div>
    );
};

export default DownloadFileButton;
